import React from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  return <motion.nav initial={{
    y: -20,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className="fixed top-0 left-0 right-0 z-50 bg-cream/80 backdrop-blur-md border-b border-warmBrown/5" data-id="element-138" data-mp="jih4rz3sg3j9">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center relative" data-id="element-139" data-mp="sbcasv12y3a3">
        <div className="flex items-center gap-2 cursor-pointer" data-id="element-140" data-mp="4m9jswkk2y2x">
          <img src="https://cdn.magicpatterns.com/uploads/mMVV4XoPmsr1QmNTgf4DWX/icon.png" alt="Pawchi logo" className="w-9 h-9 rounded-lg" data-id="element-141" data-mp="jweg99q126o" />
          <span className="font-logo font-semibold text-2xl text-warmBrown tracking-tight" data-id="element-142" data-mp="ek76vgqoioty">
            Pawchi
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8 absolute left-1/2 -translate-x-1/2" data-id="element-143" data-mp="9mnr2cec23zw">
          <a href="#how-it-works" className="font-medium text-warmBrown/70 hover:text-peach transition-colors" data-id="element-144" data-mp="1q0e0zzs4vmhg">
            How It Works
          </a>
          <a href="#features" className="font-medium text-warmBrown/70 hover:text-peach transition-colors" data-id="element-145" data-mp="9nfzuqtdhkx4">
            Features
          </a>
          <a href="#testimonials" className="font-medium text-warmBrown/70 hover:text-peach transition-colors" data-id="element-146" data-mp="epdmzw4w8zvc">
            Stories
          </a>
        </div>
      </div>
    </motion.nav>;
}